<template>
  <div :class="['user-verify step-info', verifyStatus]">
    <div :class="['step-info-i', 'step-info-prof', verifyStatus]">
      <img :src="getVerificationImg()" class="seller-trust" :alt="verifyStatus"/>
    </div>
    <p class="step-info-msg">
      {{ getVerificationMessage() }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    verifyStatus: {
      type: String,
      default: 'noverify',
    },
    isVerified: {
      type: Boolean,
      default: false
    },
    isTrusted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getVerificationMessage(status) {
      let translation;
      if(this.isTrusted) {
        translation = this.$t("Trusted seller");
      } else if(this.isVerified) {
        translation = this.$t("Verified seller");
      } else {
        translation = this.$t("Unverified seller");
      }
      // switch (status) {
      //   case 'recommended':
      //     translation = this.$t("Recommended seller");
      //     break;
      //   case 'personal':
      //     translation = this.$t("Verified seller");
      //     break;
      //   case 'business':
      //     translation = this.$t("Verified Business seller");
      //     break;
      //   case 'noverify':
      //   default:
      //     translation = this.$t("Unverified seller");
      //     break;
      // }
      return translation;
    },
    getVerificationImg() {
      let img;
      if(this.isTrusted) {
        img = '/img/seller-status/business-new.svg';
      } else if(this.isVerified) {
        img = '/img/seller-status/personal-gray.svg';
      } else {
        img = '/img/seller-status/noverify.svg';
      }
      return img;
    }
  },
};
</script>

<style lang="scss" scoped>
  .step-info{
    height: 14px;
    margin-left: 5px;
    position: relative;
    width: 14px;
    min-width: 14px;
    cursor: pointer;
    img{
      height: 14px !important;
      margin-left: 0 !important;
      width: 100% !important;
    }
    &-msg{
      background: #fff !important;
      border-radius: 6px;
      color: #505050;
      filter: drop-shadow(0 4px 15px rgba(0, 0, 0, .25));
      box-shadow: 0px 0px 15px 0px #00000026;
      font-family: Roboto-Light, sans-serif;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 400 !important;
      height: auto;
      line-height: 1.4285714286;
      max-width: 260px;
      opacity: 0;
      padding: 12px 15px !important;
      pointer-events: none;
      position: absolute;
      text-align: left !important;
      text-transform: none;
      transition: .3s !important;
      width: max-content;
      z-index: 1000;
      bottom: 30px;
      left: auto;
      right: -10px;
      top: auto;
    }
    &:hover{
      .step-info-msg{
        opacity: 1;
        pointer-events: visible;
      }
    }
  }
</style>
